import { Translations } from './types';

export const de: Translations = {
  navbar: {
    home: 'Start',
    projects: 'Projekte',
  },
  home: {
    bio: (years) => [
      `Ergebnisorientierter Senior Software Engineer mit über ${years} Jahren Erfahrung in der Entwicklung skalierbarer und wartbarer Webanwendungen mit React, Next.js, TypeScript und modernen JavaScript-Ökosystemen. Nachgewiesene Erfolgsbilanz bei der Lieferung hochwertiger Lösungen in den Bereichen Fintech, SaaS, Reisen und Bildung, mit Expertise in Full-Stack-Entwicklung, Systemarchitektur und technischer Führung. Leidenschaft für sauberen Code, Leistungsoptimierung und moderne Entwicklungspraktiken.`,
    ],
    aboutTitle: 'Über',
    aboutTitleAccent: 'Mich',
    about1: [
      'Ich bin sehr stolz auf mein Engagement für Software-Handwerkskunst und strebe stets danach, Code zu produzieren, der nicht nur sauber und effizient ist, sondern auch die Prinzipien von DRY (Don\'t Repeat Yourself) und konsistenten Entwurfsmustern einhält.',
      'Mit einem Hintergrund in der IT-Technischen Analyse ist mein Ansatz zur Problemlösung im Pragmatismus verwurzelt. Ich glaube daran, Herausforderungen mit einem tiefen Verständnis realer Einschränkungen anzugehen, um sicherzustellen, dass die von mir entwickelten Lösungen nicht nur theoretisch fundiert, sondern auch praktisch und auf die Projektanforderungen ausgerichtet sind.',
    ],
    experienceTitle: ['Unternehmen', 'mit denen ich gearbeitet habe'],
  },
  aboutMe: {
    getInTouch: 'KONTAKT AUFNEHMEN',
    messageSent: 'NACHRICHT GESENDET',
    modalTitle: 'SCHREIB MIR EINE NACHRICHT',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    subject: 'Betreff',
    cancel: 'Abbrechen',
    submit: 'Absenden',
    errors: {
      firstName: 'Bitte geben Sie Ihren Vornamen ein',
      lastName: 'Bitte geben Sie Ihren Nachnamen ein',
      email: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
      emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      subject: 'Bitte geben Sie eine Nachricht ein',
    },
  },
  projects: {
    bio: [
      'Persönliche Projekte, an denen ich im letzten Jahr oder länger gearbeitet habe.',
      'Schauen Sie sich gerne die GitHub-Links für die aufgeführten Projekte an.',
    ],
    reposTotal: 'Öffentliche GitHub-Repositories insgesamt:',
    loading: 'Projekte werden geladen...',
    repositories: 'Repositories',
    sortBy: 'Sortieren nach:',
    newest: 'Neueste',
    oldest: 'Älteste',
    sectionTitle: 'Projekte',
    sectionTitleAccent: 'Open Source',
    noDescription: 'Keine Beschreibung verfügbar.',
    created: 'Erstellt:',
    githubButton: 'GitHub ↗',
  },
  companies: {
    orchahealth: {
      title: 'Orcha Health',
      intro:
        'Senior Software Engineer mit Arbeit über den gesamten Stack einer digitalen Gesundheitsplattform, mit Beiträgen zu Frontend-Architekturverbesserungen, sicherem API-Design und End-to-End CI/CD-Pipelines unter Verwendung von Next.js, TypeScript, C#/.NET, Cypress, Storybook, MUI, SCSS, Docker und Azure DevOps.',
      highlights: [
        {
          title: 'Komponentenbibliothek-Architektur',
          body: 'Zerlegung einer monolithischen UI-Komponentenbibliothek in sechs unabhängig versionierte Pakete: eine gemeinsame Core-UI-Bibliothek primitiver Komponenten und fünf domänenspezifische Bibliotheken (Form UI, Widget UI und weitere) — nach einem unidirektionalen Abhängigkeitsmuster. Verbesserung der Frontend-Performance um 30% und Beseitigung bibliotheksübergreifender Kopplungen, die unabhängige Releases blockiert hatten.',
        },
        {
          title: 'White-Label-Lieferanten-Hub',
          body: 'Konzeption und Entwicklung einer White-Label-Webanwendung in Next.js/React/TypeScript mit JWT-Authentifizierung, rollenbasierter Zugriffskontrolle (RBAC), serverseitigem Datenabruf, lieferantenspezifischem UI-Theming (Farbschemata und Logos) und In-App-Zugang zu Gesundheitsbewertungsprodukten.',
        },
        {
          title: 'API-Sicherheit & Performance',
          body: 'Implementierung sicherer .NET-API-Endpunkte mit Rate-Limiting, JWT-Validierung und granularen Berechtigungsprüfungen. Ersatz von Ad-hoc-Abfragelogik durch optimierte gespeicherte Prozeduren und klar definierte DTOs, wodurch redundante SQL-Ausführungen beseitigt wurden, die unter hohem Datenverkehr zu intermittierenden Timeouts geführt hatten.',
        },
        {
          title: 'Sicherheits-Behebung',
          body: 'Proaktive Bewertung aller Frontend-Anwendungen auf Exposition gegenüber der Axios-1.14.1-Schwachstelle, mit Risikominderung über Legacy- und moderne Frontends hinweg. Behebung kritischer Schwachstellen in Legacy-Next.js-8-Codebasen, einschließlich HTTP-Header-Fehlkonfigurationen, npm-Supply-Chain-Exposition und einer React-RCE-Sicherheitslücke, begleitet von einem vollständigen Dependency-Audit.',
        },
        {
          title: 'CI/CD & Release-Verantwortung',
          body: 'Verantwortung für End-to-End-Frontend-Release-Prozesse aller Consumer-Anwendungen, mit Erstellung von Azure-DevOps-Pipelines von Grund auf — einschließlich mehrstufiger YAML-Build-Konfigurationen, Dockerfiles, Helm-Chart-Templating und umgebungsspezifischer Variablengruppenver­waltung — für schnelle, wiederholbare und umgebungsisolierte Deployments in Dev, Staging und Produktion.',
        },
      ],
    },
    natwest: {
      title: 'NatWest Rooster Money',
      intro:
        'Beitrag zum vollständigen UI-Rebranding nach der NatWest-Übernahme, mit Implementierung neuer Features und Behebung von Bugs in der React-Cordova-Codebasis, um die Rooster-Money-App an NatWests Design-Sprache und Markenstandards anzupassen — unter Verwendung von React, TypeScript, Redux Toolkit, SCSS und Framer Motion.',
      highlights: [
        {
          title: 'Neugestaltung des Legacy-Admin-Panels',
          body: 'Leitung des vollständigen Redesigns und Neuentwicklung eines Legacy-Admin-Panels, Migration von Handlebars, jQuery und Node.js 8 zu einer modernen Full-Stack-Architektur mit React, Redux, TypeScript, NestJS und PostgreSQL. Reduzierung der Kundensupport-Bearbeitungszeiten um 45% durch deutlich schnellere Seitenladezeiten, sicheres Routing und rollenbasierte Zugriffskontrolle via JWT-Schlüsselpaar-Authentifizierung.',
        },
        {
          title: 'Apple Pay & Google Pay Tokenisierung',
          body: 'Federführung bei der Frontend-Implementierung der Apple-Pay- und Google-Pay-Tokenisierung sowie einer serverseitig paginierten Token-Verwaltungstabelle — mit Sortier-, Sperr-, Entknüpfungs- und Löschfunktionen — zur Stärkung der Transaktionssicherheit und des Kundenvertrauens.',
        },
        {
          title: 'Händler-Sperrlisten-Feature',
          body: 'Leitung der Frontend- und Backend-Entwicklung einer Händler-Sperrlisten-Funktion, die Eltern ermöglicht, Zahlungen an bestimmte Händlerkategorien zu blockieren. Entwickelt mit React, TypeScript und Next.js im Frontend sowie RESTful-Node.js-Endpunkten im Backend, mit CRUD-Operationen über PostgreSQL. Direkter Beitrag zu NatWests Schutzpflichten für Kontoinhaber im Kindesalter.',
        },
      ],
    },
    onefile: {
      title: 'OneFile',
      intro:
        'Verantwortlich für die Frontend-Entwicklung zweier Schlüsselanwendungen: der SSR-Einschreibungs-Web-App Enrol, erstellt mit React, Next.js, Redux Toolkit und Styled-Components; sowie einer Angular-basierten internen Admin-Anwendung. Zusätzliche Beiträge zum ASP.NET-Core-/SQL-Server-Backend mit für Skalierbarkeit optimierten CRUD-Operationen. Die Plattform war auf Microsoft-Azure-Infrastruktur gehostet.',
      highlights: [
        {
          title: 'Wesentliche Features',
          body: 'Entwicklung eines dynamischen Web-Formular-Builders, PDF-Export, CSV-Import und Benutzeranmeldeauthentifizierung. Erstellung eines wiederverwendbaren Styled-Components-Designsystems für UI-Konsistenz in der gesamten Anwendung sowie einer Flask/Python-RESTful-API zur Verwaltung von Ausbildungsrichtlinien und staatlichen Vorschriften.',
        },
        {
          title: 'Tests & Qualität',
          body: 'Aufrechterhaltung umfassender Testabdeckung durch Unit-Tests, Integrationstests und Snapshot-Tests in enger Zusammenarbeit mit Projektmanagern, QA-Spezialisten und Designern in einem agilen Scrum-Framework.',
        },
        {
          title: 'Schulung & Wissenstransfer',
          body: 'Durchführung interner Schulungen zu React Hooks und responsivem CSS mit Schwerpunkt auf Flexbox- und Grid-Layout-Techniken.',
        },
      ],
    },
    tickiteline: {
      title: 'Ticketline',
      intro:
        'Leitung der Frontend-Entwicklung einer Greenfield-SSR-Ticket-Wiederverkaufsplattform, erstellt mit React, Next.js, TypeScript, Redux und SCSS, mit zusätzlichen Backend-Beiträgen via ASP.NET Core. Die Plattform war auf Microsoft-Azure-Infrastruktur gehostet.',
      highlights: [
        {
          title: 'Frontend-Architektur',
          body: 'Übernahme der Hauptverantwortung für die React-SSR-Anwendung, Entwicklung wiederverwendbarer Komponenten einschließlich eines Kalenders, einer Eventsuche mit mehrdimensionaler Filterung und serverseitig paginierten Ergebnissen — Lieferung von ca. 60% der Anwendungsfunktionalität mit 60% Unit-Test-Abdeckung.',
        },
        {
          title: 'Mentoring & Schulung',
          body: 'Durchführung interner Schulungen zu TypeScript, React SSR, HTML und fortgeschrittenen CSS-Layout-Techniken einschließlich Flexbox und Grid, um Kollegen bei der Erweiterung ihrer Fähigkeiten zu unterstützen.',
        },
        {
          title: 'Web-Scraping-Tool',
          body: 'Entwicklung eines Content-Scraping-Tools mit Python, JavaScript, HTML und CSS für das Marketing-Team zur Verfolgung von Wettbewerberpreisen, Produkt-Updates und Markterkenntnissen.',
        },
      ],
    },
    sabs: {
      title: 'SABS Travel Technologies',
      intro:
        'Schlüsselrolle bei der Entwicklung der Lightning-Geschäftsreise-Buchungsplattform mit Angular 14, TypeScript, RxJS, GraphQL, SCSS und Storybook, mit Beitrag zu einem nahtlosen und responsiven Erlebnis für Geschäftsreisende.',
      highlights: [
        {
          title: 'Flug-Sitzplan-UI',
          body: 'Konzeption und Entwicklung einer interaktiven Sitzplan-Oberfläche, die Nutzern die Auswahl von Sitzen mit detaillierten Attributen wie Eignung für Kleinkinder und Beinfreiheit ermöglicht — zur Vereinfachung des Buchungsprozesses und Verbesserung der Gesamtnutzererfahrung.',
        },
      ],
    },
    rhinogroup: {
      title: 'Rhino Group',
      intro: '',
      highlights: [
        {
          title: 'Web-Scraping-Tool',
          body: 'Entwicklung eines Content-Scraping-Tools mit Python, JavaScript, HTML und CSS, das hauptsächlich vom Marketing-Team zur Überwachung von Wettbewerberpreisen, Produkt-Updates und anderen wichtigen Markterkenntnissen eingesetzt wurde.',
        },
        {
          title: 'Individuelle CMS-Anwendung',
          body: 'Maßgebliche Beteiligung am Aufbau eines individuellen Content-Management-Systems (CMS) mit Angular, das eine mit Laravel erstellte RESTful-API verbunden mit einer MySQL-Datenbank konsumiert. Die Anwendung vereinfachte die interne Erstellung von Landing Pages und bot eine benutzerfreundliche Oberfläche für die schnelle Seitenproduktion.',
        },
      ],
    },
  },
};
